import { CheckOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import getTaskStatusColor from "helpers/getTaskStatusColor";
import { useState } from "react";

const EventItem = ({ item, actions, openCustomEditor }) => {
  const [dragging_id, setDraggingId] = useState(null);
  const all_ids = [...(item.issues || []), ...(item.tasks || [])].map(
    ({ id }) => id
  );

  switch (item.type) {
    case "multiple":
      return (
        <>
          <div
            {...actions}
            onDragStart={(e) => {
              setDraggingId(all_ids[0]);
              actions.onDragStart(e);
            }}
            onDragEnd={(e) => {
              setDraggingId(null);
              actions.onDragEnd(e);
            }}
            className={`multiple-panel${
              all_ids.includes(dragging_id) ? " dragging" : ""
            }`}
            id={item.event_id}
          >
            <div className="multiple-panel__group">
              {item.issues.map((issue) => (
                <div
                  className="issue-group"
                  key={issue.id}
                  style={{
                    background: issue.color,
                  }}
                >
                  <span>
                    {issue.client_street} {issue.client_building_number}/
                    {issue.client_apartment_number}
                  </span>
                  <br />
                  <span>
                    {issue.client_post_code} {issue.client_city}
                  </span>
                </div>
              ))}
              {item.tasks.map((a) => (
                <div className="task-group" key={a.id}>
                  <div
                    className="task-group__dot"
                    style={{
                      backgroundColor: getTaskStatusColor(a.status_color),
                    }}
                  />
                  <span className="task-group__name">{a.content}</span>
                  {a.is_completed && (
                    <div className="task-group__check">
                      <CheckOutlined />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <Button
            className="add-button"
            type="primary"
            htmlType="button"
            onClick={() => openCustomEditor(item.start)}
            icon={<PlusOutlined />}
          />
        </>
      );
    case "issue":
      const issue = item.issues[0];

      return (
        <>
          <div
            {...actions}
            onDragStart={(e) => {
              setDraggingId(issue.id);
              actions.onDragStart(e);
            }}
            onDragEnd={(e) => {
              setDraggingId(null);
              actions.onDragEnd(e);
            }}
            className={`calendar-issue-panel${
              issue.id === dragging_id ? " dragging" : ""
            }`}
          >
            <div
              id={issue?.item_id}
              className="calendar-issue-panel__inner"
              style={{
                backgroundColor: issue.color,
              }}
            >
              <span>
                {issue.client_street} {issue.client_building_number}/
                {issue.client_apartment_number}
              </span>
              <br />
              <span>
                {issue.client_post_code} {issue.client_city}
              </span>
              {issue.service_date_delay > 0 && (
                <>
                  <br />
                  <Typography.Text strong>
                    Opóźnienie: {issue.service_date_delay} minut
                  </Typography.Text>
                </>
              )}
            </div>
          </div>
          <Button
            className="add-button"
            type="primary"
            htmlType="button"
            onClick={() => openCustomEditor(item.start)}
            icon={<PlusOutlined />}
          />
        </>
      );
    case "task":
      const task = item.tasks[0];
      return (
        <>
          <div
            {...actions}
            onDragStart={(e) => {
              setDraggingId(task.id);
              actions.onDragStart(e);
            }}
            onDragEnd={(e) => {
              setDraggingId(null);
              actions.onDragEnd(e);
            }}
            className={`calendar-task-panel ${
              task.is_completed ? "completed" : ""
            }${task.id === dragging_id ? " dragging" : ""}`}
            id={task?.task_id}
          >
            <div className="calendar-task-panel__inner">
              <div className="task-group">
                <div
                  className="task-group__dot"
                  style={{
                    backgroundColor: getTaskStatusColor(task.status_color),
                  }}
                />
                <span className="task-group__name">{task.content}</span>
                {task.is_completed && (
                  <div className="task-group__check">
                    <CheckOutlined />
                  </div>
                )}
              </div>
            </div>
          </div>
          <Button
            className="add-button"
            type="primary"
            htmlType="button"
            onClick={() => openCustomEditor(item.start)}
            icon={<PlusOutlined />}
          />
        </>
      );
    default:
      return null;
  }
};

export default EventItem;
